import React from "react";

/**
 * Generic Text input
 * @param {*} param0
 */
const useRunAfterUpdate = () => {
    const afterPaintRef = React.useRef(null);
    React.useEffect(() => {
        if (afterPaintRef.current) {
            afterPaintRef.current();
            afterPaintRef.current = null;
        }
    });

    const runAfterUpdate = (fn) => (afterPaintRef.current = fn);
    return runAfterUpdate;
};

export default useRunAfterUpdate;
